import { Box, Typography } from '@mui/material'
import { FC, ReactNode } from 'react'
import { tokens } from '@/theme'

/**
 * Título de bloco dos dashboards: filete laranja à esquerda (eco do eyebrow do
 * cabeçalho), título em Ink e uma linha de leitura. `acao` vai à direita (filtro, link).
 */
export const TituloSecao: FC<{ titulo: string; descricao?: string; acao?: ReactNode }> = ({
  titulo,
  descricao,
  acao,
}) => (
  <Box
    sx={{
      mb: 2,
      display: 'flex',
      alignItems: 'flex-start',
      justifyContent: 'space-between',
      gap: 2,
      flexWrap: 'wrap',
    }}
  >
    <Box sx={{ pl: 1.5, borderLeft: `3px solid ${tokens.brandPrimary}` }}>
      <Typography sx={{ fontWeight: 700, color: tokens.brandInk }}>{titulo}</Typography>
      {descricao && (
        <Typography variant="caption" sx={{ color: tokens.textSecondary }}>
          {descricao}
        </Typography>
      )}
    </Box>
    {acao}
  </Box>
)

export default TituloSecao
